import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NewRequestPopup.ManagersList', {
    description:
        'If you think you should be added, please contact one of the company administrators and ask them to add you as a requester.',
});
